module.exports = __webpack_public_path__ + "img/14.343828de.png";